import { NbDictionaries } from '../../types';
import { atomWithBroadcast } from './atomWithBroadcast';

export const initialDictionaries: NbDictionaries = {
  accountCategoryTypes: [],
  accountProxyTypes: [],
  marketDataProviders: [],
  subscriptionPackegesProxyTypes: [],
  tradingSessions: [],
  orderExpiryTypes: [],
  orderTypes: [],
};

export const dictionariesAtom = atomWithBroadcast<NbDictionaries>('core/dictionaries', initialDictionaries);
